import { Dashboard } from "@/components/dashboard/Dashboard/Dashboard";
import { VStack } from "@/components/layout/VStack";
import { HStack } from "@/components/layout/HStack";
import { Button } from "@/components/ui/Button/Button";
import { Skeleton } from "@/components/ui/Skeleton/Skeleton";
import { Mail, MailPlus } from "lucide-react";
import { useEffect, useState } from "react";
import { useScheduledEmails } from "../hooks/emails/useScheduledEmails";
import { ScheduledEmailsTable } from "../components/emails/ScheduledEmailsTable";
import { ComposeEmailSheet } from "../components/emails/ComposeEmailSheet";
import {
  Empty,
  EmptyContent,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
} from "@/components/ui/Empty/Empty";
import type { ApiScheduledEmail } from "@shared/types/models";

const AdminEmails = (_props: { sysAdmin?: boolean } = {}) => {
  const [scheduledEmails, setScheduledEmails] = useState<ApiScheduledEmail[]>(
    [],
  );
  const [composeOpen, setComposeOpen] = useState(false);
  const { loadScheduledEmails, cancelScheduledEmail, loading } =
    useScheduledEmails();

  useEffect(() => {
    loadScheduledEmails(setScheduledEmails);
  }, []);

  const handleCancel = async (id: string) => {
    const updated = await cancelScheduledEmail(id);
    if (!updated) return;
    setScheduledEmails((prev) =>
      prev.map((email) => (email._id === updated._id ? updated : email)),
    );
  };

  const handleCreated = (created: ApiScheduledEmail) => {
    setScheduledEmails((prev) => [created, ...prev]);
  };

  return (
    <Dashboard activePage="/emails">
      <HStack justify="space-between" wrap>
        <VStack>
          <h2
            style={{
              fontSize: "var(--text-2xl)",
              lineHeight: "var(--line-height-2xl)",
              fontWeight: "var(--font-bold)",
            }}
          >
            Emails
          </h2>
          <p style={{ color: "var(--muted-foreground)" }}>
            Schedule branded emails to all students.
          </p>
        </VStack>
        <Button onClick={() => setComposeOpen(true)}>
          <MailPlus /> Schedule Email
        </Button>
      </HStack>
      {loading.scheduledEmails ? (
        <Skeleton style={{ width: "100%", height: "512px" }} />
      ) : scheduledEmails.length < 1 ? (
        <Empty style={{ borderColor: "var(--secondary-border)" }}>
          <EmptyHeader>
            <EmptyMedia variant="icon">
              <Mail />
            </EmptyMedia>
            <EmptyTitle>No Scheduled Emails</EmptyTitle>
            <EmptyDescription>
              You haven't scheduled any emails yet. Compose one to get started.
            </EmptyDescription>
          </EmptyHeader>
          <EmptyContent>
            <Button onClick={() => setComposeOpen(true)}>
              <MailPlus /> Schedule Email
            </Button>
          </EmptyContent>
        </Empty>
      ) : (
        <ScheduledEmailsTable
          data={scheduledEmails}
          onCancel={handleCancel}
        />
      )}
      <ComposeEmailSheet
        open={composeOpen}
        onOpenChange={setComposeOpen}
        onCreated={handleCreated}
      />
    </Dashboard>
  );
};

export default AdminEmails;
